/**
 * @desc 解锁
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderUnlockingCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/unlocking`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
